import type { GetProductSearchParams } from '~/modules/catalog/product/types';
import { UseContextReturn } from '~/types/core';

export const getProductDetailsCommand = {
  execute: async (context: UseContextReturn, searchParams: GetProductSearchParams, customQuery = {
    productDetails: context.app.$vsf.$magento.config.state.getLocale() === 'cn' ? 'query-product-details-cn' : 'query-product-details',
  }, customHeaders = {}) => {
    const { data } = await context.app.$vsf.$magento.api.productDetails(searchParams, customQuery, customHeaders);

    return data?.products ?? null;
  },
};
